import { render, staticRenderFns } from "./subjectwise.vue?vue&type=template&id=68bf88c6&"
import script from "./subjectwise.vue?vue&type=script&lang=js&"
export * from "./subjectwise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports